import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, BookOpenIcon, HeadphonesIcon, StarIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta-section" ref={ref} className="w-full bg-gradient-to-br from-terracotta to-terracotta/90 py-16 md:py-24 px-6" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto text-center" data-id="element-14">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-15">
          Recupera tu tranquilidad y el sueño de tu bebé hoy mismo
        </h2>

        <p className="text-xl md:text-2xl text-white/90 mb-12" data-id="element-16">
          Por un precio menor al de una caja de pañales
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-10 max-w-4xl mx-auto" data-id="element-17">
          {/* Tier 1: Ebook Only */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 flex flex-col items-center" data-id="element-18">
            <BookOpenIcon className="w-10 h-10 text-white/80 mb-4" data-id="element-19" />
            <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-20">
              Ebook
            </h3>
            <p className="text-white/70 text-sm mb-6" data-id="element-21">Terapia de Sueño 7-Min</p>

            <p className="text-white/50 text-lg line-through mb-1" data-id="element-22">$17 USD</p>
            <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3" data-id="element-23">
              -62% de descuento
            </span>
            <p className="font-serif text-4xl md:text-5xl font-bold text-white mb-1" data-id="element-24">
              $6.39
            </p>
            <p className="text-white/70 text-sm mb-6" data-id="element-25">USD · Pago único</p>

            <ul className="text-left text-white/80 text-sm space-y-2 mb-8 w-full" data-id="element-26">
              <li className="flex items-start gap-2" data-id="element-27">
                <span className="text-soft-gold mt-0.5" data-id="element-28">✓</span>
                Ebook con el método 1-2-4 completo
              </li>
              <li className="flex items-start gap-2" data-id="element-29">
                <span className="text-soft-gold mt-0.5" data-id="element-30">✓</span>
                Guía de Emergencia 3 AM
              </li>
              <li className="flex items-start gap-2" data-id="element-31">
                <span className="text-soft-gold mt-0.5" data-id="element-32">✓</span>
                Checklist "Estación de Calma"
              </li>
            </ul>

            <a href="https://serenopulse.com/cart/47610504020226:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Ebook Terapia de Sueño 7-Min', 6.39)} className="inline-block bg-white/20 hover:bg-white/30 text-white font-bold text-lg px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 w-full text-center" data-id="element-33">
              QUIERO EL EBOOK
            </a>
          </div>

          {/* Tier 2: Ebook + Audiolibro */}
          <div className="relative bg-white rounded-2xl p-8 flex flex-col items-center shadow-2xl" data-id="element-34">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-soft-gold text-white text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-1.5" data-id="element-35">
              <StarIcon className="w-3.5 h-3.5" data-id="element-36" />
              MÁS POPULAR
            </div>

            <div className="flex items-center gap-2 mb-4" data-id="element-37">
              <BookOpenIcon className="w-9 h-9 text-terracotta" data-id="element-38" />
              <span className="text-terracotta text-2xl font-bold" data-id="element-39">+</span>
              <HeadphonesIcon className="w-9 h-9 text-terracotta" data-id="element-40" />
            </div>
            <h3 className="font-serif text-2xl font-bold text-warm-brown mb-2" data-id="element-41">
              Ebook + Audiolibro
            </h3>
            <p className="text-warm-brown/60 text-sm mb-6" data-id="element-42">
              El bundle completo
            </p>

            <p className="text-warm-brown/40 text-lg line-through mb-1" data-id="element-43">
              $20 USD
            </p>
            <span className="inline-block bg-terracotta/10 text-terracotta text-xs font-semibold px-3 py-1 rounded-full mb-3" data-id="element-44">
              -53% de descuento
            </span>
            <p className="font-serif text-4xl md:text-5xl font-bold text-warm-brown mb-1" data-id="element-45">
              $9.39
            </p>
            <p className="text-warm-brown/60 text-sm mb-6" data-id="element-46">USD · Pago único</p>

            <ul className="text-left text-warm-brown/80 text-sm space-y-2 mb-8 w-full" data-id="element-47">
              <li className="flex items-start gap-2" data-id="element-48">
                <span className="text-terracotta mt-0.5" data-id="element-49">✓</span>
                Ebook con el método 1-2-4 completo
              </li>
              <li className="flex items-start gap-2" data-id="element-50">
                <span className="text-terracotta mt-0.5" data-id="element-51">✓</span>
                Guía de Emergencia 3 AM
              </li>
              <li className="flex items-start gap-2" data-id="element-52">
                <span className="text-terracotta mt-0.5" data-id="element-53">✓</span>
                Checklist "Estación de Calma"
              </li>
              <li className="flex items-start gap-2" data-id="element-54">
                <span className="text-terracotta mt-0.5" data-id="element-55">✓</span>
                <strong data-id="element-56">Audiolibro "Tu Voz es su Calma"</strong>
              </li>
            </ul>

            <a href="https://serenopulse.com/cart/47610504020226:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Ebook + Audiolibro Terapia de Sueño 7-Min', 9.39)} className="inline-block bg-terracotta hover:bg-terracotta/90 text-white font-bold text-lg px-10 py-4 rounded-full shadow-xl transition-all duration-300 hover:scale-105 w-full text-center" data-id="element-57">
              QUIERO EL BUNDLE COMPLETO
            </a>
            <p className="text-warm-brown/50 text-xs mt-3" data-id="element-58">
              Solo $3 más por el audiolibro
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-white/90" data-id="element-59">
          <div className="flex items-center gap-2" data-id="element-60">
            <ZapIcon className="w-5 h-5" data-id="element-61" />
            <span data-id="element-62">Acceso inmediato tras la compra</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-63">
            <ShieldCheckIcon className="w-5 h-5" data-id="element-64" />
            <span data-id="element-65">100% Seguro</span>
          </div>
        </div>

        <p className="text-white/80 text-sm md:text-base italic mt-8" data-id="element-66">
          Miles de mamás ya están durmiendo mejor. Únete a ellas esta noche.
        </p>
      </motion.div>
    </section>;
}